import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const assignAdminSensorOrderDevices = async (
  orderId,
  deviceIds,
  assignedAt
) => {
  const request = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/assign-devices`,
    body: { deviceIds, assignedAt },
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(request);
  return response.data;
};
